<template>
    <el-drawer :modal="false" 
        :visible.sync="drawerViewTeamMembersDetails"
        class="drawer-team-members-details"
        size="45%"
        title="Team Member"
    >
        <div slot="title" class="d-flex align-items-center" @click="modals.show_edit_team = true" style="cursor: pointer" v-if="current_team">
            <span>{{ current_team.hub_team_name }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="ml-2 text-primary"><path fill="currentColor" d="m19.3 8.925-4.25-4.2 1.4-1.4q.575-.575 1.413-.575t1.412.575l1.4 1.4q.575.575.6 1.388t-.55 1.387L19.3 8.925ZM17.85 10.4 7.25 21H3v-4.25l10.6-10.6 4.25 4.25Z"/></svg>
        </div>
        <b-container>
            <ValidationObserver v-slot="{ invalid }" ref="observer">
                <b-form>
                    <b-row>
                        <b-col>
                            <b-form-group label="Team Leader">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'teamLeader'"
                                >
                                    <el-select
                                        v-model="team.team_leader.id"
                                        filterable
                                        placeholder="Select Team Leader"
                                    >
                                        <el-option
                                            v-for="option in selectedTeamLeaderOptions[team.hub_team_id]"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        ></el-option>   
                                    </el-select>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group label="Team Members">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'teamMembers'"
                                >
                                    <!-- change v-model to only show team_member_ids only 
                                    addded new team_member_ids in resource api
                                    -->
                                    <el-select
                                        v-model="team.team_member_ids"
                                        multiple
                                        filterable
                                        placeholder="Please enter a keyword">
                                        <el-option v-for="option in selectedTeamMemberOptions[team.hub_team_id]"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id">
                                        </el-option>
                                    </el-select>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="ml-auto text-right">
                            <b-button type="button" class="w-25" variant="primary" @click="updateHubTeams(team.hub_team_id)" :disabled="invalid">Save</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>
        </b-container>

        <EditTeamModal :show_edit_team.sync="modals.show_edit_team"/>
    </el-drawer>
</template>
<script>
import { Drawer, Option, Select } from 'element-ui'
import EditTeamModal from '@/views/Commission/Hub/HubProfile/HubModals/EditTeamModal'
import { useHubStore } from '@/stores/hubStore'
import { mapState, mapActions } from 'pinia'
import { axios, services, getHeader, swal } from '@/assets/js/httpImports.js'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'

export default {
    components: {
        EditTeamModal,
        ValidationObserver,
        ValidationProvider,
        [Drawer.name]: Drawer,
        [Option.name]: Option,
        [Select.name]: Select,
    },
    data() {
        return {
            drawerViewTeamMembersDetails: false,
            modals:{
                show_edit_team: false
            },
            team: {
                team_leader: {
                    id: ''
                }
            },
            selectedTeamLeaderOptions: [],
            selectedTeamMemberOptions: []
        }
    },
    async created() {
        this.$watch(
            'current_team',
            (newVal, oldVal) => {
                if (newVal) {
                    this.team = newVal
                }
            }
        )
    },
    mounted() {
        this.getEditHubSaleManagerList(this.$route.params.hub_team_id)
        this.getEditHubTeamMemberList(this.$route.params.hub_team_id)
    },
    computed: {
        ...mapState(useHubStore,['current_team'])
    },
    methods: {
        ...mapActions(useHubStore,['getHubTeams']),
        async viewTeamMembersDetails() {
            this.drawerViewTeamMembersDetails = !this.drawerViewTeamMembersDetails;
            // await this.getEditHubSaleManagerList(this.$route.params.hub_team_id);
            // await this.getEditHubTeamMemberList(this.$route.params.hub_team_id);
        },
        async getEditHubSaleManagerList(hub_team_id) {
            axios.get(services.hub + 'get_edit_hub_team_user_options_list/leader/' + hub_team_id, { headers: getHeader() })
            .then(response => {
                // add in hub_team_id to determine which array list belongs to which team
                this.selectedTeamLeaderOptions[hub_team_id] = response.data.data
                this.$forceUpdate();
            })
            .catch ( error => {
                this.errorFunction(error, "Showing User Listing failed: " + error.response.data.message) 
            });
        },
        async getEditHubTeamMemberList(hub_team_id) {
            await axios.get(services.hub + 'get_edit_hub_team_user_options_list/member/' + hub_team_id, { headers: getHeader() })
            .then(response => {
                // use hub team id for prevent javascript auto random re-arrange problem
                this.selectedTeamMemberOptions[hub_team_id] = response.data.data;
                this.$forceUpdate();
            })
            .catch ( error => {
                this.errorFunction(error, "Showing User Listing failed: " + error.response.data.message) 
            });
        },
        // update hub team details, leader, and hub team name
        updateHubTeams(hub_team_id) {
            // check whether the team leader is being selected or not, before proceed to save function
            if(!this.team.team_leader.id)
            {
                this.redErrorNotify( '<b>Invalid Input : Team Leader is Mandatory </b>')
            }
            else 
            {
                const postData = {
                    hub_id: this.team.hub.hub_id,
                    hub_team_name: this.team.hub_team_name,
                    user_id: this.team.team_leader.id,
                }
                const str = JSON.stringify(postData);

                axios.put(services.hub + 'hub_team/' + hub_team_id, postData ,{ headers: getHeader() })
                .then ( response =>  {
                    if (response.status === 200)
                    {
                        this.$notify({
                            message:
                            '<b>Hub Sale Team - ' + response.data.data.team_leader.name + ' </b> - Successfully Updated.',
                            timeout: 10000,
                            icon: 'ni ni-bell-55',
                            type: 'default',
                        });
                        // if success updated hub team, then only update hub team members
                        this.createHubTeamMemberData(hub_team_id);
                        
                    }
                })
                .catch ( error => {
                    this.errorFunction(error, "Update Hub Sale Team Failed")
                });
            }
        },
        createHubTeamMemberData(hub_team_id) {
            if (this.team.team_member_ids.length < 9) {
                const postData = {
                    hub_id: this.team.hub.hub_id,
                    hub_team_id: hub_team_id,
                    member_id: this.team.team_member_ids,
                }

                axios.post(services.hub + 'hub_team_member', postData, { headers: getHeader() })
                .then(() => {
                    this.$notify({
                        message:
                        '<b>Hub Sale Team Member </b> - Successfully Updated.',
                        timeout: 10000,
                        icon: 'ni ni-bell-55',
                        type: 'default',
                    });

                    this.getHubTeams(this.current_team.hub_team_id);
                })
                .catch( error => {
                    this.errorFunction(error, "Insert Hub Team Member Failed")
                });
            } else {
                this.$notify({
                    message:
                    '<b>Hub Sale Team Members </b> Failed - Not Updated.',
                    timeout: 10000,
                    icon: 'ni ni-bell-55',
                    type: 'danger',
                });
            }
        },
    }
}
</script>